export default {
    data() {
        return {
            loading: false,
            isDisabled: false, // Disables form when it's in preview mode
            recaptchaToken: '',
            validRecaptcha: true,
            signaturePadValid: true,
        };
    },
    methods: {
        submit() {
            const { data, isEmpty } = this.$refs.signaturePad.$refs.signaturePad.saveSignature();
            this.$refs.signaturePad.$data.valid = !isEmpty;
            this.validRecaptcha = !!this.recaptchaToken;
            this.loading = true;
            if (this.$refs.form.validate() && !isEmpty && this.recaptchaToken) {
                const formData = _.clone(this.$store.state.secure_sign_forms[this.form]);
                formData['signature'] = data;
                const cleanFormData = this.clearFormData(formData);
                const requestData = {
                    form_type: this.formType,
                    data: cleanFormData,
                };
                axios
                    .post(route('api.v1.ssf.submit'), requestData)
                    .then(() => {
                        this.$root.goTo(route('users.index'));
                        return this.$root.notify('info', t('default::notification.success'));
                    })
                    .catch((error) => {
                        this.$root.parseErrorsAndNotify(error);
                        this.loading = false;
                    });
            } else {
                this.loading = false;
            }
        },
        getFormData() {
            const urlSearchParams = new URLSearchParams(window.location.search);
            const uuid = urlSearchParams.get('preview');
            if (uuid) {
                this.isDisabled = true;
                axios.get(route('api.v1.ssf.preview', { formSubmission: uuid })).then((response) => {
                    Object.entries(response.data.data).forEach(([key, value]) =>
                        this.$store.dispatch('secure_sign_forms/updateProperty', {
                            value,
                            property: `${this.form}.${key}`,
                        })
                    );
                });
            }
        },
        clearFormData(obj) {
            return Object.fromEntries(
                Object.entries(obj).filter((entry) => entry[1] !== '' && entry[1] !== undefined && entry[1] !== null)
            );
        },
        onRecaptchaVerify(response) {
            this.recaptchaToken = response;
            this.validRecaptcha = true;
        },
        expired() {
            if (this.$refs.recaptcha) {
                this.$refs.recaptcha.reset();
            }
            this.validRecaptcha = false;
        },
    },
};
